import type { Guide } from '../types';

/**
 * S-26.10-04 — konfiguracja raportu klienta (scenariusz e2e 35; makieta p. Mariusza, ekran 9, BR-CS-08).
 * Dane: klient „DEMO Klient raporty” z konfiguracją „DEMO Plan dostaw tygodniowy” (`seed-e2e.ts`).
 */
export const guide: Guide = {
  flagKey: 'clientReportConfig',
  title: 'Raporty dla klientów: konfiguracja raportu klienta',
  whatItDoes:
    'CS ustala, jaki raport dostaje klient: zakres zleceń (po dacie załadunku albo rozładunku), lokalizacje, pola — kierowca i numer terminala tylko na żądanie klienta — częstotliwość, godzinę wysyłki, adresatów i format pliku. Każda konfiguracja ma właściciela i datę, od której obowiązuje; każda zmiana wymaga powodu i trafia do historii. Wysyłka automatyczna: nie — raport akceptuje i wysyła CS.',
  audience: ['CS', 'Team Leader CS', 'administrator'],
  presentationItems: ['S-26.10-04'],
  steps: [
    {
      route: '/client-report-configs',
      target: 'client-report-configs',
      title: 'Konfiguracje raportów',
      description:
        'Lista konfiguracji: klient i nazwa raportu, zakres i lokalizacje, pola, harmonogram z najbliższym terminem, właściciel i data obowiązywania.',
      action: 'Otwórz w menu „Konfiguracja raportów”.',
      recorder: { account: 'cs' },
    },
    {
      route: '/client-report-configs',
      target: 'client-report-config-form',
      title: 'Nowa konfiguracja',
      description:
        'Klient z kartoteki, nazwa raportu, zakres w dniach od dnia raportu, częstotliwość i godzina wysyłki, format pliku, właściciel, „obowiązuje od”, adresaci, lokalizacje i zakres pól. Powód jest obowiązkowy.',
      action: 'Kliknij „Nowa konfiguracja”, wypełnij pola, wpisz powód i kliknij „Zapisz konfigurację”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-config-new' }] },
    },
    {
      route: '/client-report-configs',
      target: 'cs-konfig-godzina',
      mockupTestId: 'cs-konfig-godzina',
      title: 'Godzina wysyłki',
      description:
        'Godzina w czasie polskim — dwie godziny wcześniej raport trafia do kolejki z danymi z tej chwili, żeby CS zdążył go przejrzeć.',
      action: 'Wpisz godzinę w polu „Godzina wysyłki”.',
      recorder: { account: 'cs', actions: [{ kind: 'click', target: 'client-report-config-new' }] },
    },
    {
      route: '/client-report-configs',
      target: 'client-report-config-history-*',
      title: 'Historia konfiguracji',
      description: 'Kto i kiedy założył albo zmienił konfigurację, co było, co jest i z jakiego powodu.',
      action: 'Przy konfiguracji kliknij „Historia”.',
      recorder: {
        account: 'cs',
        actions: [{ kind: 'clickButton', name: 'Historia', rowText: 'DEMO Plan dostaw tygodniowy' }],
      },
    },
  ],
};
